import React from 'react'
import { Box } from '@mui/material'
import { State, PartialAction, Position } from 'src/types'
import { BaseSetter } from 'src/features/yellStory/Components/BaseSetter'
import { ColorSetter } from 'src/features/yellStory/Components/ColorSetter'
import { EmbroiderySetter } from 'src/features/yellStory/Components/EmbroiderySetter'
import { useRouter } from 'next/router'
import { SettingButtons } from 'src/Components/Domain/SettingButtons'
import { SimulationConfirmDialog } from 'src/features/simulationConfirm/Components/SimulationConfirmDialog'
import { SettingTabs } from 'src/Components/Domain/SettingTabs'

type Props = {
  state: State
  figurePanelNum: number
  dispatch: React.Dispatch<PartialAction>
}

export const Setters: React.FC<Props> = ({ state, figurePanelNum, dispatch }) => {
  const [selectedIndex, setSelectedIndex] = React.useState(0)
  const [isDialogOpen, setIsDialogOpen] = React.useState<boolean>(false)
  const router = useRouter()
  const urlParams = router.asPath.split('/')
  const lastIndex = urlParams.length - 1
  const position = urlParams[lastIndex] as Position
  const handleDialogClose = () => setIsDialogOpen(false)
  const handleDialogOpen = () => setIsDialogOpen(true)
  return (
    <Box border={'solid 1px #3f51b5'}>
      <SettingTabs {...{ selectedIndex, setSelectedIndex }} />
      <BaseSetter {...{ state, selectedIndex, dispatch }} />
      <ColorSetter {...{ state, selectedIndex, figurePanelNum, dispatch }} />
      <EmbroiderySetter {...{ state, selectedIndex, dispatch }} />
      <SettingTabs {...{ selectedIndex, setSelectedIndex }} />
      <SettingButtons {...{ handleDialogOpen }} />
      <SimulationConfirmDialog {...{ state, position, isDialogOpen, handleDialogClose, dispatch }} brand={'yellStory'} />
    </Box>
  )
}
